import { render, staticRenderFns } from "./BodyMassIndex.vue?vue&type=template&id=70661010&scoped=true"
import script from "./BodyMassIndex.vue?vue&type=script&lang=js"
export * from "./BodyMassIndex.vue?vue&type=script&lang=js"
import style0 from "./BodyMassIndex.vue?vue&type=style&index=0&id=70661010&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70661010",
  null
  
)

export default component.exports